export default __webpack_public_path__ + "static/media/day10.bdeb8dde.png";